import {css} from 'emotion'
import {Colors, PushTitle, Link, MenuLink, H2} from './..'
import URL from './../../static/quizz.jpg'

export const HubQuizzStyle = () => css({
  'h2': {
    textAlign: 'center',
    fontSize: '2rem',
    fontWeight: 'bold',
    textTransform: 'uppercase',
  },
  '.quizz': {
    boxShadow: `0 0 20px 0 ${Colors.shadow}`,
    '.btn': {
      ...Link,
      display: 'inline-block',
      height: '60px',
      lineHeight: '60px',
      padding: '0px 1.5rem',

      '@media (min-width: 1224px)': {
        padding: '0px 3rem',
      },

      'span': {
        display: 'inline-block',
        verticalAlign: 'middle',
        lineHeight: 1.2
      }
    },
    '&-inner': {
      backgroundColor: '#000',
      'p': {
        color: 'white',
      },
      'h3': {
        color: 'white',
        fontWeight: 'bold',
        textTransform: 'uppercase',
        margin: 0,
      },
      '.score': {
        color: Colors.red,
        fontWeight: 'bold',
        fontSize: '1.3125rem',
      }
    }
  },
  '.current-quizz': {
    '&-inner': {
      background: `black url(${URL}) no-repeat center`,
      backgroundSize: 'cover',
      maxWidth: '100%',
      flexBasis: '100%',
      padding: '2rem',
      '@media (min-width: 1024px)': {
        maxWidth: 'calc(9/12 * 100%)',
        flexBasis: 'calc(9/12 * 100%)',
        padding: '5rem',
      },
      'h3': {
        ...PushTitle,
      },
      '.btn': {
        background: Colors.red,
        color: 'white',
        transition: 'all 200ms ease',
        '&:hover': {
          background: 'black',
          color: 'white',
        }
      }
    },
    '&-info':{
      maxWidth: '100%',
      flexBasis: '100%',
      textAlign: 'center',
      '@media (min-width: 1024px)': {
        maxWidth: '50%',
        flexBasis: '50%',
        textAlign: 'left',
      }
    },
    '&-link': {
      mmaxWidth: '100%',
      flexBasis: '100%',
      display: 'flex',
      justifyContent: 'center',
      '@media (min-width: 1024px)': {
        maxWidth: '50%',
        flexBasis: '50%',
        justifyContent: 'flex-end',
      },
    },
    '&-days': {
      maxWidth: '100%',
      flexBasis: '100%',
      padding: '2rem', 
      textAlign: 'center',
      color: Colors.red,
      '@media (min-width: 1024px)': {
        maxWidth: 'calc(3/12 * 100%)',
        flexBasis: 'calc(3/12 * 100%)',
      },
      '.label': {
        display: 'block',
        ...MenuLink,
      },
      '.days':{
        ...H2,
        fontWeight: 'bold',
        margin: '1rem 0',
      }
    },
  },
  '.hub-quizz-previous': {
    margin: '4rem 0',
    'p': {
      textAlign: 'center',
    },
    'h3': {
     fontSize: '2rem',
    },
  },
  '.previous-quizz': {
    maxWidth: '100%',
    flexBasis: '100%',
    margin: '2rem',
    '@media (min-width: 1024px)': {
      maxWidth: 'calc(50% - 2rem)',
      flexBasis: 'calc(50% - 2rem)',
    },
    '&:nth-child(odd)': {
      marginLeft: 0,
    },
    '&:nth-child(even)': {
      marginRight: 0,
    },
    '.btn': {
      color: Colors.grey,
      border: `1px solid ${Colors.mediumGrey}`,
      transition: 'all 200ms ease',
      '&:hover': {
        color: 'white',
        background: 'black',
      }
    },  
    '&-inner': {
      padding: '2rem',
      textAlign: 'center',
      maxWidth: '100%',
      flexBasis: '100%',
      '@media (min-width: 1024px)': {
        padding: '4rem 2rem',
        maxWidth: 'calc(1/2 * 100%)',
        flexBasis: 'calc(1/2 * 100%)',
      },
    },
    '&-days': {
      padding: '2rem',
      maxWidth: '100%',
      flexBasis: '100%',
      textAlign: 'center',
      '@media (min-width: 1024px)': {
        padding: '4rem 2rem',
        maxWidth: 'calc(1/2 * 100%)',
        flexBasis: 'calc(1/2 * 100%)',
        textAlign: 'left',
      },
      'p': {
        textAlign: 'center',
        marginTop: 0,
        '@media (min-width: 1024px)': {
          textAlign: 'left',
        }
      }
    }
  },
})


// WEBPACK FOOTER //
// ./src/styles/containers/hubQuizz.js